import React, { useEffect, useRef, useImperativeHandle, forwardRef } from 'react';
import EditorJS from '@editorjs/editorjs';
import createEditorTools from './EditorTools';
import './Editor.css';

// `data` is read once on mount; remount (via `key`) to load different content.
const Editor = forwardRef(({ data, placeholder = '' }, ref) => {
    const instanceRef = useRef(null);
    const holderRef = useRef(null);

    useImperativeHandle(ref, () => ({
        save: async () => (instanceRef.current ? instanceRef.current.save() : null),
    }));

    useEffect(() => {
        const editor = new EditorJS({
            holder: holderRef.current,
            data,
            tools: createEditorTools(),
            placeholder,
        });
        instanceRef.current = editor;

        return () => {
            instanceRef.current = null;
            editor.isReady.then(() => editor.destroy()).catch(() => {});
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return <div ref={holderRef} className="dealzy-editor" />;
});

export default Editor;
